const botonX = document.querySelector('.botonesNav .icono');
const botonZ = document.querySelector('.menuParaHab .titulo-loader');
botonX.addEventListener('click', function() {
    const verMenu = document.querySelector('div.menuParaHab');
    verMenu.classList.toggle('fade-out');
});
botonZ.addEventListener('click', function() {
    const verMenu = document.querySelector('div.menuParaHab');
    verMenu.classList.toggle('fade-out');
});

const conTarjetas =  document.querySelector('#contenedorTarjetas');
const preLoader = document.querySelector('.preloader');



document.addEventListener('DOMContentLoaded', importarBitacora);
async function importarBitacora() {
    
    const url = 'https://script.google.com/macros/s/AKfycbxGnYasniJXpAFlvld89mmaLTtfkTI6CwYZaqv2Y1Skwr3B3XJ9qIywQI03IawcJ4Oruw/exec';
    try {
        const respuesta = await fetch(url);
        const resultado = await respuesta.json();
        leerResultado(resultado.reverse());
        preLoader.classList.toggle('fade-out');
    } catch (error) {
        console.log('Algo esta fallando en mi codiga asi: ',error)
    }
}


function leerResultado(data) {
    let fileID = '1vvPuEB3vU89MZdn_tpb2--vGx3lDRk2V'
    
    
    data.forEach(element => {
        const div01 = document.createElement('DIV');
        if(element.img) {
            div01.innerHTML = `

            <!-- Tarjeta principal que contiene todo el informe -->
            <div class="card-body">
            
                <!-- Encabezado con la información del usuario -->
                <div class="card-head">
                    <img class="logo-head" src="/public/img/icon${element.empresa}.png" alt="Logo Satarem" class="rounded-circle profile-img me-3">
                    <div class="texto-head">
                        <h5 class="card-title mb-0 fw-bold">${element.autor}</h5>
                        <p class="card-subtitle text-muted mb-0">${element.cargo}</p>
                    </div>
                </div>

                <!-- Cuerpo del mensaje del informe -->
                <div class="foto-contenedor">
                    <img class="foto-publica" src="https://drive.google.com/thumbnail?sz=w1000&id=${element.img}" style="width:100% loading="lazy"">
                    
                </div>
        
                <div class="report-content">
                    ${element.mensaje}
                </div>

                <!-- Botón/Footer con la fecha del comentario -->
                <div class="fecha-coment">
                    <div class="btn-fecha">
                        Comentario realizado el: ${element.fecha}
                    </div>
                </div>

            
            </div>

            `;
        }else {
            div01.innerHTML = `

            <!-- Tarjeta principal que contiene todo el informe -->
            <div class="card shadow-sm report-card mb-2 style="width: 18rem;">
                <div class="card-body p-4 p-md-5">
            
                    <!-- Encabezado con la información del usuario -->
                    <div class="card-head">
                        <img class="logo-head" src="/public/img/icon${element.empresa}.png" alt="Logo Satarem" class="rounded-circle profile-img me-3">
                        <div class="texto-head">
                            <h5 class="card-title mb-0 fw-bold">${element.autor}</h5>
                            <p class="card-subtitle text-muted mb-0">${element.cargo}</p>
                        </div>
                    </div>

            <!-- Cuerpo del mensaje del informe -->
          
    
            <div class="report-content">
                ${element.mensaje}
            </div>

            <!-- Botón/Footer con la fecha del comentario -->
            <div class="fecha-coment">
                <div class="btn-fecha">
                    Comentario realizado el: ${element.fecha}
                </div>
            </div>

        </div>
    </div>

        `;
        }
        
        conTarjetas.appendChild(div01);
    });
}

function mostrarSpinner() {
    if(spinner.classList.contains('wrapper')) {
        spinner.setAttribute('hidden', true);
    }
}